import { useMemo } from 'react';
import { LICENSE_PLATE_REGEX } from '../../constants/regex';

export default function useIsLicensePlateValid(licensePlate: string) {
  return useMemo(() => {
    return licensePlate !== '' ? LICENSE_PLATE_REGEX.test(licensePlate) : true;
  }, [licensePlate]);
}
